{
  "version": 1,
  "asset_id": "d67070cc-08e6-450a-aa31-d5793e1c5a99",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/d67070cc-08e6-450a-aa31-d5793e1c5a99/tools-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/d67070cc-08e6-450a-aa31-d5793e1c5a99/tools-card.webp",
  "original_filename": "tools-card.webp",
  "size": 43190,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:34Z"
}
